import {
    ADD_INTEGRATION_REQUEST,
    ADD_INTEGRATION_RESULT,
    ADD_INTEGRATION_OPEN_MODAL,
    ADD_INTEGRATION_CLOSE_MODAL,
    ADD_INTEGRATION_GET_INTEGRATIONS_REQUEST,
    ADD_INTEGRATION_GET_INTEGRATIONS_RESULT,
    ADD_INTEGRATION_CEREBRUMX_REQUEST,
    ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_REQUEST,
    ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_RESULT
} from 'Redux/actionTypes';

export const addIntegrationRequest = (data) => ({
    type: ADD_INTEGRATION_REQUEST,
    payload: data
})

export const addCompanyIntegrationRequest = (data) => ({
    type: ADD_INTEGRATION_CEREBRUMX_REQUEST,
    payload: data
})

export const addIntegrationResult = (result) => ({
    type: ADD_INTEGRATION_RESULT,
    payload: result
})

export const addIntegrationOpenModal = (data) => ({
    type: ADD_INTEGRATION_OPEN_MODAL,
    payload: data
})

export const addIntegrationCloseModal = () => ({
    type: ADD_INTEGRATION_CLOSE_MODAL
})

export const addIntegrationGetIntegrationsRequest = (item, accountId) => ({
    type: ADD_INTEGRATION_GET_INTEGRATIONS_REQUEST,
    payload: { devices: item, accountId: accountId }
})

export const addIntegrationGetIntegrationsResult = (result) => ({
    type: ADD_INTEGRATION_GET_INTEGRATIONS_RESULT,
    payload: result
})

export const addIntegrationCerebrumXGetFleetsRequest = () => ({
    type: ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_REQUEST
})

export const addIntegrationCerebrumXGetFleetsResult = (result) => ({
    type: ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_RESULT,
    payload: result
})
